export const dailyDaypartForecastTestIDs = {
  dayName: 'daily_weather_forecast_daypart_day_day_name',
  sunriseLabel: 'daily_weather_forecast_daypart_day_sunrise_label',
  sunriseValue: 'daily_weather_forecast_daypart_day_sunrise_value',
  sunsetLabel: 'daily_weather_forecast_daypart_day_sunset_label',
  sunsetValue: 'daily_weather_forecast_daypart_day_sunset_value',
  weatherIconDay: 'daily_weather_forecast_daypart_day_weather_icon',
  tempuratureTextDay: 'daily_weather_forecast_daypart_day_tempurature',
  forecastTextDay: 'daily_weather_forecast_daypart_day_forecast',
  nightName: 'daily_weather_forecast_daypart_night_night_name',
  moonPhaseLabel: 'daily_weather_forecast_daypart_night_moon_phase_label',
  moonPhaseValue: 'daily_weather_forecast_daypart_night_moon_phase_value',
  weatherIconNight: 'daily_weather_forecast_daypart_night_weather_icon',
  tempuratureTextNight: 'daily_weather_forecast_daypart_night_tempurature',
  forecastTextNight: 'daily_weather_forecast_daypart_night_forecast',
};
